/** @const */ export var DEFAULT_ENCODING = 'utf-8';
//# sourceMappingURL=defaultEncoding.js.map